'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhotosAndVideos = getPhotosAndVideos;

var _ChronotrackApi = require('../apis/ChronotrackApi');

var _rx = require('rx');

function getPhotosAndVideos(_ref) {
  var eventId = _ref.eventId;
  var entryId = _ref.entryId;

  var streamId = 'getPhotosAndVideos';
  return _ChronotrackApi.ChronotrackApi.memoizeQuery(streamId, 'results/' + eventId + '/entry/' + entryId).map(function (msg) {
    return {
      photos: msg.photos,
      videos: msg.videos
    };
  });
}


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/MediaNoble.js
// module id = 424
// module chunks = 0